import { GridApiPremium } from "@mui/x-data-grid-premium/models/gridApiPremium";
import { MutableRefObject, useEffect } from "react";
import { projectAnalysis, TotalCo2Configurator } from "../../../types/analysis/ProjectAnalysis";

/**
 * Custom hook that synchronizes the visible columns in a DataGrid with the ProjectAnalysis totalCo2Config.
 * When columns are changed (shown/hidden), it automatically updates the ProjectAnalysis configuration
 * to include only the viable CO2 columns that are currently visible.
 * 
 * @param apiRef - Reference to the DataGrid API
 */
const useTotalCo2ConfigSync = (apiRef: MutableRefObject<GridApiPremium>) => {
  // Get the current visible column definitions

  // Effect to update totalCo2Config when visible columns change
  useEffect(() => {
    const handleColumnVisibilityModelChange = () => {
      const visibleColumns = apiRef.current.getVisibleColumns();

      // Get the valid TotalCo2Configurator keys
      const totalCo2Configurator = new TotalCo2Configurator();
      const viableConfigKeys = Object.keys(totalCo2Configurator) as (keyof TotalCo2Configurator)[];

      // Filter visible columns to only include viable CO2 configuration columns
      const viableColumns: string[] = [];
      visibleColumns.forEach(column => {
        if (viableConfigKeys.includes(column.field as keyof TotalCo2Configurator)) {
          viableColumns.push(column.field);
        }
      });
      console.log('Visible columns:', viableColumns);

      // Update the ProjectAnalysis configuration if we have viable columns
      if (viableColumns.length > 0) {
        projectAnalysis.setTotalCo2Config(viableColumns);
        console.log('Updated totalCo2Config with visible columns:', viableColumns);
      } else {
        projectAnalysis.setTotalCo2Config(['totalCo2']);
      }
    };

    return apiRef.current?.subscribeEvent('columnVisibilityModelChange', handleColumnVisibilityModelChange);
  }, [apiRef]);
};

export default useTotalCo2ConfigSync;
